
import { ChangeDetectorRef, Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ColDef, ColumnApi, GridApi, GridReadyEvent, ICellRendererParams, IRowNode, RowClickedEvent, RowNode } from '@ag-grid-community/core';
import { DialogService } from 'src/app/services/dialog.service';
import { FormServices } from 'src/app/services/form.services';
import { FormulaServices } from 'src/app/services/formula.service';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { Variable } from '../../formula-tester/formula-tester.component';
import { StringUtils } from 'src/app/system-utils/utils/StringUtils';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { NgxSpinnerService } from 'ngx-spinner';
import { ItensPermission } from 'src/app/interfaces/RolePermission';
import { PermissionServices } from 'src/app/services/permission.services';
import { Subscription } from 'rxjs';
import { localePt } from "../../../../assets/locale.pt.js";
import { ThemeService } from 'src/app/services/theme.service';
import { LanguageServices } from 'src/app/services/LanguageServices';

@Component({
    selector: 'd-para-view',
    templateUrl: './d-para-view.component.html',
    styleUrls: ['./d-para-view.component.scss'],
    standalone: false
})
export class DParaViewComponent implements OnInit {

  @ViewChild('step') private carouselContainer: ElementRef<HTMLDivElement>
  readonly contentTypeCodes = [
    {
      name:'Texto',
      contentType:1  
    },
    {
      name:'Decimal',
      contentType:2  
    },
    {
      name:'Inteiro',
      contentType:3  
    },
    {
      name:'Data/Hora',
      contentType:4  
    },
    {
      name:'Texto Longo',
      contentType:5  
    },
    {
      name:'Byte',
      contentType:6
    },
    {
      name:'JSON',
      contentType:7
    },
    {
      name:'Texto2 ( Sem Tratamento )',
      contentType:8  
    },
    {
      name:'XML',
      contentType:9
    },
    {
      name:'Verdadeiro/Falso',
      contentType:10  
    },
    {
      name:'JSON Ordernado',
      contentType:11  
    }
  ] as const;

  readonly dataTypeCodes = [
    {
      name:'Constante/Fórmula',
      dataType:1,
      active: true  
    },
    {
      name:'Consulta SQL',
      dataType:2,
      active: true
    },
    {
      name:'D/Para',
      dataType:4,
      active: true,
    },
    {
      name:'JSON',
      dataType:5,
      active: true  
    },
    {
      name:'XML',
      dataType:6,
      active: true,
      toolTip: 'Ao usar essa opção, o sistem procura pelo campo informado na Expressão. Passando a funcionar como um De/Para, usando o Path no campo DE'
    },
    {
      name:'Sankhya DBExplorer',
      dataType:7,
      active: false,
      toolTip: 'Opção para fazer consulta no banco da Sankhya, opção restrita.'
    },
    {
      name:'VARIABLE',
      dataType:9,
      active: true
    }
  ] as const;


  active:Boolean = true;
  //displayedColumns: string[] = ['sequenceft', 'active', 'datatype',  'contenttype', 'fromdata', 'todata','expression'];
  rows:any[] = [];
  private gridApi!: GridApi;
  prefixFrom:string = '';
  prefixTo:string = '';
  displayedColumns:ColDef[] = [
    {
        headerName: "Sequência",
        field: "SEQUENCEFT",
        flex:1,
        resizable:true
    },
    {
      headerName: "Ativo",
      field: "ACTIVE",
      flex:2,
      resizable:true,
      valueFormatter: (param)=>{
        return  this.getDesc(param.value,'ACTIVE');
      },
      cellRenderer: (params)=> {
          if (params.value =='S'){
            return `<span class="active-chip">${params.valueFormatted}</span>`
          }else{
            return `<span class="inactive-chip">${params.valueFormatted}</span>`
          }
      }
    },
    {
      headerName:"Tipo Processo",
      field: 'DATATYPE',
      resizable:true,
      flex:3,
      valueFormatter: (param)=>{
          return param.value + ' - ' + this.getDesc(param.value,'DATATYPE');
      }
    },
    {
      headerName:"Tipo de Dados",
      field: 'CONTENTTYPE',
      resizable:true,
      flex:3,
      valueFormatter: (param)=>{
        return param.value + ' - ' + this.getDesc(param.value,'CONTENTTYPE');
      }
    },
    {
      headerName:"Expressão",
      field: 'EXPRESSION',
      resizable:true,
      flex:5
    },
    {
      headerName:"De",
      field: 'FROMDATA',
      resizable:true,
      flex:3
      
    },
    {
      headerName:"Para",
      field: 'TODATA',
      resizable:true,
      flex:3
      
    }



];
  selectedNodes: IRowNode<any>[];
  sequenceFt: any = null;
  sub2: Subscription;
  sub3: Subscription;
  sub4: Subscription;
  sub5: Subscription;
  sub6: Subscription;
  sub7: Subscription;

  constructor(public http:HTTPService, public fb:UntypedFormBuilder, private formulaService:FormulaServices,
    private formServices:FormServices, private snackBar:SnackbarService, private dialogServices:DialogService,
    private spinner:NgxSpinnerService,
    private permissionService:PermissionServices,
    public ThemeService:ThemeService,
    public ls:LanguageServices) { }

  @Input()integrationData:any;
  @Input()cfiForm:UntypedFormGroup;
  @Input()step3:FormGroup<any>;
  thirdFormGroup:UntypedFormGroup;
  firstFormGroup:UntypedFormGroup;
  secondFormGroup:UntypedFormGroup;
  editFace = false;
  showD = false;
  showFormula = true;
  disableExpression = true;
  disableOthers = true;
  showSuspendedMenuFrom = false;
  supendedDataFrom:String[] = [];
  showSuspendedMenuTo = false;
  supendedDataTo:String[] = [];
  titleFrom:string;
  titleTo:string;
  dataTypeCodesReal:Object[] = [];
  canEdit: boolean = false;
  canInsert: boolean = false;
  canDelete: boolean = false;
  canView: boolean = false;
  
  
  
  ngOnInit(): void {

        
    let itemsPermission:ItensPermission =  this.permissionService.checkPermission('Mktpcid');
    this.canEdit = itemsPermission.canEdit;
    this.canInsert = itemsPermission.canInsert;
    this.canDelete = itemsPermission.canDelete;
    this.canView = itemsPermission.canView;

    this.dataTypeCodesReal.push(...this.dataTypeCodes);

    
    if ( this.integrationData.typeIntegration.nuInt == 1){
        this.titleFrom = "Campos De";
        this.prefixFrom ="SQL.";
        let query = this.cfiForm.get('EXPRESSION').value;
        if ( query != null ){
          this.loadFieldsQuery(query).then((data:string[])=>{
            this.supendedDataFrom = data;
          });
        }
    }

    if ( this.integrationData.typeIntegration.nuInt == 2){
        this.dataTypeCodesReal.find(d=>d['dataType']==4)['active'] = false;
    }else{
      this.dataTypeCodesReal.find(d=>d['dataType']==4)['active'] = true;
    }
    
    if ( this.integrationData.typeIntegration.nuInt == 4 ||this.integrationData.typeIntegration.nuInt == 7 ){
        this.titleTo = "Campos Para";

        let expression = null;
        if ( this.integrationData.typeIntegration.nuInt == 4) {
          expression = this.cfiForm.get('EXPRESSION').value;
        }else{
          expression = this.step3.get('MAINTAGNAME').value;
        }        
        
        if ( expression!= null ){
          this.loadFieldsEntity(expression).then((data:string[])=>{
            this.supendedDataTo = data;
            
            if ( this.supendedDataTo.length > 0 ){
              this.showSuspendedMenuTo = true;
            }
          });
        }    
    }

    this.firstFormGroup = this.fb.group({
      ACTIVE: new UntypedFormControl("S"),
      CONTENTTYPE: new UntypedFormControl(null),
      DATATYPE: new UntypedFormControl(null),
      FROMDATA: new UntypedFormControl(null),
      TODATA: new UntypedFormControl(null),
      IDCONF: new UntypedFormControl(this.integrationData.idConf),
      SEQUENCE: new UntypedFormControl(this.integrationData.sequence),
    });

    this.secondFormGroup = this.fb.group({
      EXPRESSION: new UntypedFormControl(null),
    })

    this.thirdFormGroup = this.fb.group({
      
      CDATA: new UntypedFormControl(null),
      CONDITIONALEXECUTION: new UntypedFormControl(null),
      EXECORDER: new UntypedFormControl(1),
      FORMATDATE: new UntypedFormControl(null),
      IDENTIFIER: new UntypedFormControl(null),
      JOINSQL: new UntypedFormControl(null),
      NEWJSON: new UntypedFormControl(null),
      NEWXML: new UntypedFormControl(null),
      SENDNULL: new UntypedFormControl(null),
      STRINGRULES: new UntypedFormControl(null),
      TAGNAME: new UntypedFormControl(null),
      TOFORMULA: new UntypedFormControl(null),
    })

    if ( this.canView ){
      this.loadData().then(d=>{
        if ( d ){
            this.initialize();
        }
      });
    }
    
  }
  loadFieldsEntity(expression: string) {
    
    return  new Promise((resolve, reject) => {
      
      let entityName = '';
      let query = null;
      if ( expression== null || expression==""){
        resolve(true);
        return;
      }else{
          if ( this.integrationData.typeIntegration.nuInt == 4 ){
            let objExpression  = JSON.parse(expression);
            if (  objExpression['destino']!= null ){
              entityName = StringUtils.toDisCamelCase( objExpression['destino']);    
              query = `SELECT MKTPDICCOL.COLUMNNAME, MKTPDIC.INSTANCENAME FROM MKTPDICCOL INNER JOIN MKTPDIC ON MKTPDICCOL.IDINSTANCE=MKTPDIC.IDINSTANCE
              WHERE MKTPDIC.IDINSTANCE=(SELECT TOP 1 IDINSTANCE 
                FROM MKTPDIC WHERE INSTANCENAME='${entityName}')`
            }
            
          }else{
            entityName = expression;
            query = `SELECT MKTPDICCOL.COLUMNNAME, MKTPDIC.INSTANCENAME FROM MKTPDICCOL INNER JOIN MKTPDIC ON MKTPDICCOL.IDINSTANCE=MKTPDIC.IDINSTANCE
              WHERE MKTPDIC.IDINSTANCE=${expression}`;
          }
      }

      if ( query == null ){
          return;
      }

      let queryBuscaAcoes = {
        entityName: "Mktpdiccol",
        sql: query
      };
    
      this.sub6 = this.http
        .post(
          queryBuscaAcoes,
          "JsonBrokerServices/findnative",
          false,
          true,
          true
        )
        .subscribe((con) => {
            let resultSet:Object[] = con["SQL"];
            let fields:String[] = resultSet.map((d:Object)=>{return StringUtils.toDisCamelCase( d['INSTANCENAME'] )+"."+d['COLUMNNAME']});
            resolve(fields);
          });
      });
  
  }
  
  loadFieldsQuery( query ) {
    
    return  new Promise((resolve, reject) => {
  
      if ( query== null || query==""){
        resolve(true);
        return;
      }
  
      let queryBuscaAcoes = {
        entityName: "Mktpdic",
        sql: query,
        testMode: true
      };
    
      this.sub7 = this.http
        .post(
          queryBuscaAcoes,
          "JsonBrokerServices/findnative",
          false,
          true,
          true
        )
        .subscribe((con) => {
            let resultSet = con["SQL"];
            let fields:String[] = Object.keys(resultSet[0]);
            resolve(fields);
          });

      });
  }

  initialize(){

  }

  selectRow(row){
      if ( this.canEdit ){
        this.firstFormGroup.reset();
        this.secondFormGroup.reset();
        this.thirdFormGroup.reset();
        this.formServices.refreshFormObject(this.firstFormGroup,row.data);
        this.formServices.refreshFormObject(this.secondFormGroup,row.data);
        this.formServices.refreshFormObject(this.thirdFormGroup,row.data);
        this.active = row.data.ACTIVE=='S'?true:false;
        this.editFace = true;
        this.sequenceFt = row.data['SEQUENCEFT'];
        this.changeDataTypeView(row.data["DATATYPE"]);
      }else{
          this.snackBar.showError("Usuário não possui permissão para edição.");
      }

      
  }

  ngOnDestroy(){
    if ( this.sub2!= null ){this.sub2.unsubscribe();}
    if ( this.sub3!= null ){this.sub3.unsubscribe();}
    if ( this.sub4!= null ){this.sub4.unsubscribe();}
    if ( this.sub5!= null ){this.sub5.unsubscribe();}
    if ( this.sub6!= null ){this.sub6.unsubscribe();}
    if ( this.sub7!= null ){this.sub7.unsubscribe();}
    
  }

  loadData(){

    return new Promise((resolve,reject)=>{
      let obinfo = {
        "entityName":"Mktpcid",
        "sql":`SELECT * FROM MKTPCID (nolock) WHERE IDCONF=${this.integrationData.idConf} AND SEQUENCE=${this.integrationData.sequence} 
        ORDER BY SEQUENCEFT`
      }         
          
      this.sub2 = this.http.post(obinfo,'JsonBrokerServices/findnative',false,true,true).subscribe(conInfo=>{
        let info =  conInfo['SQL'];
        let data = info.map(column => ({ ...column}));
        this.rows = data;
        resolve(true);
        this.spinner.hide('dparaform')
      },error=>{
        this.spinner.hide('dparaform')
      });
    });    
  }

  add(){
      this.firstFormGroup.reset();
      this.secondFormGroup.reset();
      this.thirdFormGroup.reset();
      this.firstFormGroup.get("IDCONF").setValue(this.integrationData.idConf);
      this.firstFormGroup.get("SEQUENCE").setValue(this.integrationData.sequence);
      this.thirdFormGroup.get("EXECORDER").setValue(1);
      if ( this.active ){
        this.firstFormGroup.get("ACTIVE").setValue("S");
      }else{
        this.firstFormGroup.get("ACTIVE").setValue("N");
      }
      this.editFace = true;
  }

  remove(){
    this.sequenceFt = null;
    this.removeLine();
  }
  
  
  save(){
    this.saveDataCID();
  }

  changeDataType(evento){
    this.changeDataTypeView(evento.value);
  }

  changeDataTypeView(value){
    if (value != null && value!=''){
      this.disableExpression = true;
    }

    if ( value == 6 &&  this.integrationData.typeIntegration.nuInt == 1){
      if ( this.supendedDataFrom.length > 0 ){
        this.showSuspendedMenuFrom = true;
      }else{
        this.showSuspendedMenuFrom = false;
      }
      if ( this.supendedDataTo.length > 0 ){
        this.showSuspendedMenuTo = true;
      }else{
        this.showSuspendedMenuTo = false;
      }
      
    }

    if ( value == 4 ||  this.integrationData.typeIntegration.nuInt == 4){
      if ( this.supendedDataFrom.length > 0 ){
        this.showSuspendedMenuFrom = true;
      }else{
        this.showSuspendedMenuFrom = false;
      }
      if ( this.supendedDataTo.length > 0 ){
        this.showSuspendedMenuTo = true;
      }else{
        this.showSuspendedMenuTo = false;
      }

      if ( value == 4 ){
        this.showD = true;
      }else{
        this.showD = false;
      }
      
    }

    if ( value == 2){
      this.showFormula = false;
    }else{
      this.showFormula = true;
    }
    
  }


  onToggleChange(column){

    if ( column=='ACTIVE'){
      if ( this.active ){
        this.firstFormGroup.get(column).setValue("S");
      }else{
        this.firstFormGroup.get(column).setValue("N");
      }      
    }
  }

  openFormula( inp,field:string, formGroup:UntypedFormGroup){
    let params:Variable[] = [];
    
    this.formulaService.openFormula(inp,params).then(formula=>{
        formGroup.get(field).setValue(formula);
    });
  }

  openQuery( inp,field:string, formGroup:UntypedFormGroup){
    let params:Variable[] = [];
    inp = this.formulaService.openQuery(inp,params).then(formula=>{
      formGroup.get(field).setValue(formula);
    });
  }


  getDesc(value:any, type){
    
    if ( value == null){
      return null;
    }
    if ( type=='ACTIVE'){
        if ( value == "S"){
            return 'Ativo';
        }else{
          return 'Inativo';
        }
    }

    if ( type == 'CONTENTTYPE'){
        return this.contentTypeCodes.find(d=>d.contentType == value).name;
    }

    if ( type == 'DATATYPE'){
      return this.dataTypeCodes.find(d=>d.dataType == value).name;
    }

  }

  onGridReady(event: GridReadyEvent) {
    //this.gridColumnApi = event.columnApi;
    this.gridApi = event.api;    

    if ( !this.canView){
      this.gridApi.showNoRowsOverlay();
    }
  }
  
  getNextSequenceFt(){

    return new Promise((resolve,reject)=>{
      let sqlFindSequenceCfg = ` SELECT MAX(SEQUENCEFT)+1 AS SEQUENCEFT FROM MKTPCID WHERE IDCONF = ${this.integrationData.idConf} AND SEQUENCE=${this.integrationData.sequence}`;

      let queryFindSequence = {
        entityName: "MKTPCID",
        sql: sqlFindSequenceCfg,
      };
  
      this.sub3 = this.http
        .post(
          queryFindSequence,
          "JsonBrokerServices/findnative",
          false,
          true,
          true
        )
        .subscribe((con) => {
          let mktpCidResult = con["SQL"];
  
          let sequenceFt = 1;
          
          if (mktpCidResult != null && mktpCidResult.length > 0) {
            if (mktpCidResult[0]["SEQUENCEFT"]) {
              sequenceFt = mktpCidResult[0]["SEQUENCEFT"];
            }
          }

          resolve(sequenceFt);
        },error=>{
          this.spinner.hide('dparaform');
        });
    })
    

  }
  
  async saveDataCID() {

    this.spinner.show('dparaform');
    if ( this.sequenceFt == null ){
      await this.getNextSequenceFt().then(seq=>{
          this.sequenceFt = seq;
      })
    }

    let sequenceFt = this.sequenceFt;

    return new Promise((resolve, reject) => {

          let ob = {
              entityName:'Mktpcid',
              IDCONF:this.integrationData.idConf,
              SEQUENCE: this.integrationData.sequence,
              SEQUENCEFT:sequenceFt,
              ...this.firstFormGroup.getRawValue(),
              ...this.secondFormGroup.getRawValue(),
              ...this.thirdFormGroup.getRawValue(),
            }
  
            this.sub4 = this.http.post(ob,'JsonBrokerServices/save',false,true,true).subscribe(data=>{      
              this.loadData().then(d=>{
                this.editFace = false;
                this.sequenceFt = null;
                resolve(true);
                this.spinner.hide('dparaform');
              });    
            },error=>{
              this.spinner.hide('dparaform')
            });
          });
      
  }


  eventGridSelect(event: RowClickedEvent) {
    this.selectedNodes = event.api.getSelectedNodes();
  }

  removeLine() {
  
    this.spinner.show('dparaform');
    let cnt = this.selectedNodes.length;

    if (cnt == 0) {
      this.snackBar.showError("Nenhuma linha selecionada.");
      return;
    }

    try {
      this.dialogServices.title = "Exclusão de Dados";
      this.dialogServices.openNewDialog(
        "Excluir os itens selecionados?",
        () => {
          this.selectedNodes.forEach(async (rowNode: RowNode) => {
            let x = rowNode.data;
            let ob: Object = {};

            let remove: Object = {};
            let condition: string = `IDCONF=${rowNode.data.IDCONF} AND SEQUENCE=${rowNode.data.SEQUENCE} AND SEQUENCEFT=${rowNode.data.SEQUENCEFT}`
            remove["entityName"] = 'Mktpcid';
            remove["condition"] = condition;

            this.sub5 = await this.http
              .post(remove, "JsonBrokerServices/remove", false)
              .subscribe(
                (x) => {
                  this.snackBar.showSuccess("Registro excluido com sucesso");
                  this.gridApi.applyTransaction({ remove: [rowNode.data] });
                },
                (error) => {
                  throw error;
                }
              );
          });
          this.spinner.hide('dparaform');
        },
        () => {
          this.spinner.hide('dparaform');
        }
      );
    } catch (Exception) {
      throw Exception;
    }
  }

  refresh(){
    if ( this.canView ){
      this.loadData();
    }else{
        this.gridApi.showNoRowsOverlay();
    }
  }

}
